













import { Component, Provide } from 'vue-property-decorator';
import Vue from 'vue';
import ThanksMessagePc from '@/components/ViewComponent/Thanks/ThanksMessage/ThanksMessagePc.vue';
import SideBarPc from '@/components/ViewComponent/Thanks/SideBar/SideBarPc.vue';
import BorderCard from '@/components/Helper/Card/BorderCard.vue';

@Component<ThanksMessage>({
  components: { BorderCard, ThanksMessagePc, SideBarPc },
})
export default class ThanksMessage extends Vue {
  sideDrawer: boolean = null;

  @Provide('toggleSideDrawer')
  toggleSideDrawer(): void {
    this.sideDrawer = !this.sideDrawer;
  }
}
